export type AppView =
  | 'dashboard'
  | 'certificates'
  | 'clients'
  | 'reminders'
  | 'reviews'
  | 'bookings'
  | 'quotes'
  | 'superadmin'
  | 'admin'
  | 'faq'
  | 'tasks'
  | 'financial'
  | 'emails'
  | 'ops'
  | 'process-numbers'
  | 'owner-analytics';

export const APP_VIEWS: AppView[] = [
  'dashboard',
  'certificates',
  'clients',
  'reminders',
  'reviews',
  'bookings',
  'quotes',
  'superadmin',
  'admin',
  'faq',
  'tasks',
  'financial',
  'emails',
  'ops',
  'process-numbers',
  'owner-analytics',
];
